import { IMAGE_TYPE_UPLOAD } from '@/commons/constants';
import ExistedFilesModal from '@/components/Modals/ExistedFilesModal';
import { ImageListDraggable } from '@/components/Modals/ExistedFilesModal/UploadedFileContent';
import { FileModel, FileType } from '@/types';
import { FC, useEffect } from 'react';
import { Accept } from 'react-dropzone';
import { v4 as uuidv4 } from 'uuid';

import './styles.scss';

type FileUploaderModalProps = {
  value?: FileModel[] | FileModel;
  multiple?: boolean;
  accept?: Accept;
  onChange?: (newFiles: FileModel[]) => void;
  contentTypes?: FileType[];
};

const FileUploaderModalField: FC<FileUploaderModalProps> = (props: FileUploaderModalProps) => {
  const {
    onChange,
    value = [],
    multiple = true,
    accept = IMAGE_TYPE_UPLOAD.accept,
    contentTypes = IMAGE_TYPE_UPLOAD.contentType,
  } = props;
  const valueL = Array.isArray(value) ? value : [value];
  useEffect(() => {
    const converted = (Array.isArray(value) ? value : [value]).map((file) => {
      if (!file.uniqueId) {
        return {
          ...file,
          uniqueId: uuidv4(),
        };
      }
      return file;
    });

    if (onChange) {
      onChange(converted);
    }
  }, []);

  const removeFile = (item: FileModel) => {
    if (onChange) {
      onChange(
        valueL.filter((f: FileModel) => !(f.uniqueId === item.uniqueId || f.id === item.id))
      );
    }
  };
  return (
    <div className="cvta-content-upload-image-model">
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <ExistedFilesModal
          multiple={multiple}
          value={valueL}
          onSubmit={onChange}
          accept={accept}
          contentTypes={contentTypes}
        />
      </div>
      <div className="image-container">
        {!!(valueL && valueL.length) && (
          <ImageListDraggable
            multiple={multiple}
            content={valueL}
            onRemoveItem={removeFile}
            scrollable={false}
            onUpdateContent={onChange}
          />
        )}
      </div>
    </div>
  );
};

export default FileUploaderModalField;
